module.exports = __webpack_public_path__ + "img/hero1.b3cf461e.jpg";